import extend from 'lodash/extend'

export function evalFn (fn) {
  const Fn = Function
  return new Fn('return ' + fn)()
}

/**
 * 将配置文件转为可识别css像素
 * @param {*} config 
 * @returns 
 */
export function transfCssUtil (conf = {}) {
  if (Array.isArray(conf)) {
    conf = arrToPx(conf)
  }
  // return recursionCss(conf)
  const temp = recursionCss(conf)
  return JSON.parse(pxToRem(JSON.stringify(temp)))
}

function recursionCss (conf) {
  let temp = {}
  for (let prop in conf) {
    if (isObj(conf[prop])) {
      temp[prop] = recursionCss(conf[prop])
    } else if (Array.isArray(conf[prop])) {
      temp[prop] = arrToPx(conf[prop])
    } else {
      temp[prop] = conf[prop]
    }
  }
  return temp
}

/**
 * 判断一个值是否为数字或者字符串形式的数字
 * @param {any} value - 需要检查的值
 * @returns {boolean} - 如果是数字或者字符串形式的数字返回 true，否则返回 false
 */
function isNumberOrNumericString (value) {
  if (typeof value === 'boolean') return false

  // 检查数字类型（排除 NaN）
  if (typeof value === 'number') return !isNaN(value)

  // 检查字符串类型
  if (typeof value === 'string') {
    // 去除首尾空格（按需选择是否需要严格校验）
    const str = value.trim()
    if (!str) return false // 排除空字符串

    // 用正则表达式匹配数字格式：
    // ^[+-]?          => 可选正负号
    // (\d+\.?\d*      => 整数或小数（如 123、123.45）
    // |\.\d+)         => 允许以点开头的小数（如 .45）
    // ([eE][+-]?\d+)? => 科学计数法（如 3e5、-2.7E+10）
    // $               => 确保整个字符串匹配
    return /^[+-]?(\d+\.?\d*|\.\d+)([eE][+-]?\d+)?$/.test(str)
  }

  return false
}

// 数组转可识别像素
export function arrToPx (arr) {
  return arr.map(item => {
    if (isNumberOrNumericString(item)) {
      return `${item}px`
    } 
    return item
  }).join(' ')
}

// pxToRem
export function pxToRem (str, options) {
  const pxRegex = /(\d*\.?\d+)px/ig

  options = extend({
    rootValue: 16,
    unitPrecision: 5,
    minPixelValue: 0
  }, options)

  function createPxReplace(rootValue, unitPrecision, minPixelValue) {
    return function (m, $1) {
      if (m.indexOf('px') === -1) {
        return m
      }
      if (!$1) {
        return m
      }
      let pixels = parseFloat($1)

      if (pixels < minPixelValue) {
        return m
      }
      return toFixed((pixels / rootValue), unitPrecision) + 'rem'
    }
  }

  function toFixed(number, precision) {
    let multiplier = Math.pow(10, precision + 1)
    let wholeNumber = Math.floor(number * multiplier)
    return Math.round(wholeNumber / 10) * 10 / multiplier
  }

  let pxReplace = createPxReplace(options.rootValue, options.unitPrecision, options.minPixelValue)

  return str.replace(pxRegex, pxReplace)
}

function isObj (obj) {
  if (Object.prototype.toString.call(obj) === '[object Object]') {
    return true
  } else {
    return false
  }
}

/** 处理额外的样式细节点 */
export function execStyle (confClone, dataObject, key) {
  const config = confClone.__config__
  if (config.tag === 'el-image' && confClone.__slot__.link) {
    dataObject[key]['cursor'] = 'pointer'
  }
  if (config.tagIcon === 'container') {
    if (confClone.style.background) {
      dataObject['style']['background'] = `url(${confClone.style.background}) center center / cover no-repeat`
    } else {
      dataObject['style']['background-color'] = confClone.style.backgroundColor
    }
  }
}

function genAOSAnimationAttrs (config) {
  return {
    'data-aos': config.name,
    'data-aos-duration': config.duration,
    'data-aos-delay': config.delay,
    'data-aos-easing': config.easing,
  }
}
function genWOWAnimationAttrs (config) {
  return {
    // 'data-wow-iteration': 2,
  }
}

export function genAnimationAttrs (options = {}, dataObject) {
  const { lib, enabled, config } = options 
  if (!enabled || !lib || !config) {
    return 
  }
  let animationAttrs = {}
  if (lib === 'aos') {
    animationAttrs = genAOSAnimationAttrs(config)
  } else if (lib === 'wow') { 
    animationAttrs = genWOWAnimationAttrs(config)
    dataObject.class['wow'] = true
    dataObject.class[`animate__${config.name}`] = true
  }
  Object.keys(animationAttrs).forEach(key => {
    dataObject.attrs[key] = animationAttrs[key]
  })
}

// 设备类型
export const READDEVICEPC = 'pc'
export const READDEVICEPAD = 'pad'
export const READDEVICEMOBILE = 'mobile'

export function getCurrentDevice () {
  const ua = navigator.userAgent
  // 检测是否为平板设备
  if (/Tablet|iPad/i.test(ua)) {
    return READDEVICEPAD
  }
  // 检测是否为移动设备（手机）
  if (/Mobi|Android|iPhone|iPod|BlackBerry/i.test(ua)) {
    return READDEVICEMOBILE
  }
  // 默认返回PC
  return READDEVICEPC
}

export function getDevice (width) {
  if (width) {
    if (width > 1280) {
      return READDEVICEPC
    } else if (width > 740 && width <= 1280) {
      return READDEVICEPAD
    } else {
      return READDEVICEMOBILE
    }
  } else {
    return getCurrentDevice()
  }
}

// export const READDEVICELIST = [{
//   label: '电脑端',
//   value: READDEVICEPC,
//   icon: 'computer',
//   width: 1920
// }, {
//   label: 'Pad端',
//   value: READDEVICEPAD,
//   icon: 'pad',
//   width: 1280
// }, {
//   label: '手机端',
//   value: READDEVICEMOBILE,
//   icon: 'mobile',
//   width: 740
// }]
